import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

// project imports
import Loader from './Loader';
import ErrorBoundaryFallback from './ErrorBoundary';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component: any) => (props: any) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default Loadable;
